module.exports = __webpack_public_path__ + "static/media/SDFSA_4-317w.14ca481e.webp";